/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminElementCaptureRoom
 */
export interface InputAdminElementCaptureRoom {
    /**
     * 
     * @type {string}
     * @memberof InputAdminElementCaptureRoom
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminElementCaptureRoom
     */
    name?: string;
}

/**
 * Check if a given object implements the InputAdminElementCaptureRoom interface.
 */
export function instanceOfInputAdminElementCaptureRoom(value: object): boolean {
    return true;
}

export function InputAdminElementCaptureRoomFromJSON(json: any): InputAdminElementCaptureRoom {
    return InputAdminElementCaptureRoomFromJSONTyped(json, false);
}

export function InputAdminElementCaptureRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminElementCaptureRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function InputAdminElementCaptureRoomToJSON(value?: InputAdminElementCaptureRoom | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

